import script from "./FileManager.vue?vue&type=script&setup=true&lang=js"
export * from "./FileManager.vue?vue&type=script&setup=true&lang=js"

import "./FileManager.vue?vue&type=style&index=0&id=027ebee3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027ebee3"]])

export default __exports__